import gql from 'graphql-tag';
import FieldsBookingComplete from "graphql/fields/FieldsBookingComplete";
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'employee_guid': 'String!',
	'booking_date': '[String]',
	'active': '[String]',
	'status': '[String]',
}

export default gql(`
	query employee_bookings( ${ HelperGraphql.createFields( fields ) } ) {
		employee_bookings( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBookingComplete}
		}
	}
`);

